import { ApiRoute } from "PFCore/utilities/routes";

export const fetchCustomType = (id) =>
  // @ts-ignore
  $.ajax({
    url: ApiRoute(`/api/custom_types/${id}`),
    api_version: 2
  });

export const updateCustomType = (id, payload) =>
  // @ts-ignore
  $.ajax({
    url: ApiRoute(`/api/custom_types/${id}`),
    method: "PUT",
    contentType: "application/json",
    api_version: 2,
    data: JSON.stringify({ ...payload })
  });

export const updateCustomTypeOrderable = (id, orderable) =>
  // @ts-ignore
  $.ajax({
    url: ApiRoute(`/api/custom_types/${id}/orderable`),
    method: "PUT",
    contentType: "application/json",
    api_version: 2,
    data: JSON.stringify({ orderable })
  });
